import './MobileMenuForward.scss';
import './NavLink.scss';
import React from 'react';
import PropTypes from 'prop-types';
import CaretIcon from 'components/shared/icons/CaretIcon';

class MobileMenuForward extends React.Component {
  static propTypes = {
    callback: PropTypes.func.isRequired,
    className: PropTypes.string,
    stringID: PropTypes.string.isRequired,
  }

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  }

  render() {
    const { callback, className, stringID } = this.props;
    const { getString } = this.context;

    /* TODO: Use <button> instead of <a> */
    return (
      <a href="#" onClick={callback} className={`aa-nav-link aa-nav-forward ${className}`}>
        {getString(stringID)}
        <span className="svg-float-wrap">
          <CaretIcon direction="right" size={14} />
        </span>
      </a>
    );
  }
}

export default MobileMenuForward;
